import React from "react";

const StatusBadge = ({ date, status }) => {

  if (status === "Cancelled") {
    return (
      <span className="px-3 py-1 bg-red-100 text-red-600 rounded-full text-xs">
        Cancelled
      </span>
    );
  }

  const today = new Date();
  const bookingDate = new Date(date);

today.setHours(0, 0, 0, 0);

const booking = new Date(bookingDate);
booking.setHours(0, 0, 0, 0);

if (booking < today) {
  return (
    <span className="px-3 py-1 bg-gray-200 text-gray-600 rounded-full text-xs">
      Completed
    </span>
  );
}

  return (
    <span className="px-3 py-1 bg-emerald-100 text-emerald-600 rounded-full text-xs">
      Upcoming
    </span>
  );
};

export default StatusBadge;